// Configuration values for the application
const API_URL = window.location.hostname === 'localhost' ? 
  `${window.location.protocol}//${window.location.hostname}:5005` : 
  `${window.location.protocol}//${window.location.hostname}`;

// Export configuration values
export {
  API_URL
}; 